import Image from '@tiptap/extension-image'

function positiveInteger(value) {
  if (typeof value !== 'number' && typeof value !== 'string') return null

  const text = String(value).trim()
  // parseInt would turn legacy CSS lengths such as "50%" into the wrong pixel size.
  if (!/^\d+$/.test(text)) return null

  const number = Number(text)
  return Number.isSafeInteger(number) && number > 0 ? number : null
}

function integerAttribute(name, htmlName = name) {
  return {
    default: null,
    parseHTML: (element) => positiveInteger(element.getAttribute(htmlName)),
    renderHTML: (attributes) => {
      // Commands/JSON content bypass parseHTML, so validate again when serializing.
      const value = positiveInteger(attributes[name])
      return value === null ? {} : { [htmlName]: value }
    },
  }
}

// addAttributes is extension configuration, not an option passed to Image.configure.
export const ExtendedImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: integerAttribute('width'),
      height: integerAttribute('height'),
      assetId: integerAttribute('assetId', 'data-asset-id'),
    }
  },
})
